、<template>
<span class="CustomRead">
    <el-button class="CustomReadBtn" :type="btnType" @click="handleDialogShow">
        <slot name='btnText'>{{btnText ? btnText : $t(/*自定义读取操作*/'command.custom_read')}}</slot>
    </el-button>
    <el-dialog class="CustomReadDialog" :title="btnText ? btnText : $t(/*自定义读取操作*/'command.custom_read')" @close="handleDialogClose"
        :visible.sync="dialogShow" :modal-append-to-body="false" :close-on-click-modal="false"  width="800px">
        <div class="dialog-container" v-loading='loading'>
            <div class="form-item ">
                <el-button type="primary" @click="handleSelectAll">{{$t(/*全选*/'c.check_all')}}</el-button>
                <el-button type="primary" @click="handleClearSelect" plain>{{$t(/*全不选*/'c.clear_all')}}</el-button>
            </div>
            <div class="form-item afs short-key">
                <div class="key">BKV:</div>
                <div class="val">{{bkv}}</div>
            </div>
            <el-checkbox-group v-model="selectCmd" class="checkbox-box">
                <el-checkbox v-for="(item, index) of cmdList" :key="index" :label="item.value" @change="(v) => handleChange(v, index)" class="checkbox-item">
                    0x{{item.value.toString(16).toLocaleUpperCase()}} {{$t(item.key)}} {{item.bkv ? `[${item.bkv}]` : ''}}
                </el-checkbox>
            </el-checkbox-group>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleDialogClose">{{$t(/*取消*/'c.cancel')}}</el-button>
            <el-button @click="handleDialogConfirm" type="primary" :loading="loading">{{$t(/*确定*/'c.confirm')}}</el-button>
        </div>
    </el-dialog>
</span>
</template>

<script>
import Core from '@/core'
import BKV  from '@/core/bkv/bkv'
import {makeReadFrame} from '@/core/bkv/parse'

const CMD_LIST = {
    '26005': [
        { value: 0x12, bkv: '', key: 'device.bms_id', text: 'BMS ID' },
        { value: 0x14, bkv: '', key: 'device.gsm_signal_strength', text: 'GSM模块信号强度' },
        { value: 0x15, bkv: '', key: 'device.gps_signal_strength', text: 'GPS接收信号强度' },
        { value: 0x16, bkv: '', key: 'device.gps_satellite_in_view_count', text: '可见范围内GPS卫星数量' },
        { value: 0x17, bkv: '', key: 'device.gnss_satellite_used_count', text: '可见范围内GNSS卫星数量' },
        { value: 0x21, bkv: '', key: 'device.location_status', text: '定位状态' },
        { value: 0x25, bkv: '', key: 'device.longitude', text: '经度' },
        { value: 0x26, bkv: '', key: 'device.latitude', text: '纬度' },
        { value: 0x27, bkv: '', key: 'device.speed', text: '速度' },
        { value: 0x28, bkv: '', key: 'device.angle', text: '角度' },
        { value: 0x41, bkv: '', key: 'device.voltage', text: '电池电压' },
        { value: 0x42, bkv: '', key: 'device.current', text: '电池电流' },
        { value: 0x43, bkv: '', key: 'device.soc', text: '电池SOC' },
        { value: 0x44, bkv: '', key: 'device.temperature_sensor', text: '温度传感器' },
        { value: 0x45, bkv: '', key: 'device.remaining_capacity', text: '剩余容量' },
        { value: 0x46, bkv: '', key: 'device.full_charge_capacity', text: '充满容量' },
        { value: 0x47, bkv: '', key: 'device.cycle_count', text: '电池循环次数' },
        { value: 0x48, bkv: '', key: 'device.rated_capacity', text: '额定容量' },
        { value: 0x49, bkv: '', key: 'device.rated_voltage', text: '额定电压' },
        { value: 0x50, bkv: '', key: 'device.version', text: '电池版本信息' },
        { value: 0x51, bkv: '', key: 'device.manufacture_date', text: '生产日期' },
        { value: 0x53, bkv: '', key: 'device.manufacture_name', text: '制造商名称' },
        { value: 0x54, bkv: '', key: 'device.name', text: '电池名称' },
        { value: 0x55, bkv: '', key: 'device.chem_id', text: '电芯型号' },
        { value: 0x56, bkv: '', key: 'device.bms_bar_code', text: '电池条码' },
        { value: 0x57, bkv: '', key: 'device.low_cell_voltage', text: '低16节电压数据' },
        { value: 0x58, bkv: '', key: 'device.high_cell_voltage', text: '高16节电压数据' },
        { value: 0x59, bkv: '', key: 'device.battery_most_value_log', text: '电池最值记录' },
        { value: 0x60, bkv: '', key: 'device.error_count', text: '错误计数' },
        { value: 0x67, bkv: '', key: 'device.battery_status', text: '电池状态' },
        { value: 0x71, bkv: '', key: 'device.temperature', text: '温度' },
        { value: 0x72, bkv: '', key: 'device.gprs_stat', text: 'GPRS数据量统计' },
        { value: 0x73, bkv: '', key: 'device.dtu_software_version', text: '软件版本' },
        { value: 0x74, bkv: '', key: 'device.bms_software_version', text: 'BMS软件版本' },
        { value: 0x75, bkv: '', key: 'device.bluetooth_mac', text: '蓝牙 MAC' },
        { value: 0xE1, bkv: '', key: 'device.iccid', text: 'ICCID' },
        { value: 0xE2, bkv: '', key: 'device.imei', text: 'IMEI' },
        { value: 0xE3, bkv: '', key: 'device.gprs_apn', text: 'GPRS APN' },
        { value: 0xE4, bkv: '', key: 'device.bluetooth_password', text: '蓝牙连接密码' },

        { value: 0xE5, bkv: '', key: 'device.gprs_apn', text: 'GPRS APN' },
        { value: 0xE6, bkv: '', key: 'device.bluetooth_password', text: '蓝牙连接密码' },
        { value: 0x78, bkv: '', key: 'device.module_access_parameters', text: '模块接入参数' },
        { value: 0x79, bkv: '', key: 'device.activate_module_upgrade', text: '激活模块升级' },
        { value: 0x80, bkv: '', key: 'device.set_battery', text: '配置电池' },
        { value: 0x81, bkv: '', key: 'device.electronic_fence', text: '设置电子围栏' },
    ],
    '26006': [
        { value: 0x12, bkv: '', key: 'device.bms_id', text: 'BMS ID' },
        { value: 0x14, bkv: '', key: 'device.gsm_signal_strength', text: 'GSM模块信号强度' },
        { value: 0x15, bkv: '', key: 'device.gps_signal_strength', text: 'GPS接收信号强度' },
        { value: 0x16, bkv: '', key: 'device.gps_satellite_in_view_count', text: '可见范围内GPS卫星数量' },
        { value: 0x17, bkv: '', key: 'device.gnss_satellite_used_count', text: '可见范围内GNSS卫星数量' },
        { value: 0x21, bkv: '', key: 'device.location_status', text: '定位状态' },
        { value: 0x25, bkv: '', key: 'device.longitude', text: '经度' },
        { value: 0x26, bkv: '', key: 'device.latitude', text: '纬度' },
        { value: 0x27, bkv: '', key: 'device.speed', text: '速度' },
        { value: 0x28, bkv: '', key: 'device.angle', text: '角度' },
        { value: 0x41, bkv: '', key: 'device.voltage', text: '电池电压' },
        { value: 0x42, bkv: '', key: 'device.current', text: '电池电流' },
        { value: 0x43, bkv: '', key: 'device.soc', text: '电池SOC' },
        { value: 0x44, bkv: '', key: 'device.temperature_sensor', text: '温度传感器' },
        { value: 0x45, bkv: '', key: 'device.remaining_capacity', text: '剩余容量' },
        { value: 0x46, bkv: '', key: 'device.full_charge_capacity', text: '充满容量' },
        { value: 0x47, bkv: '', key: 'device.cycle_count', text: '电池循环次数' },
        { value: 0x48, bkv: '', key: 'device.rated_capacity', text: '额定容量' },
        { value: 0x49, bkv: '', key: 'device.rated_voltage', text: '额定电压' },
        { value: 0x50, bkv: '', key: 'device.version', text: '电池版本信息' },
        { value: 0x51, bkv: '', key: 'device.manufacture_date', text: '生产日期' },
        { value: 0x53, bkv: '', key: 'device.manufacture_name', text: '制造商名称' },
        { value: 0x54, bkv: '', key: 'device.name', text: '电池名称' },
        { value: 0x55, bkv: '', key: 'device.chem_id', text: '电芯型号' },
        { value: 0x56, bkv: '', key: 'device.bms_bar_code', text: '电池条码' },
        { value: 0x57, bkv: '', key: 'device.low_cell_voltage', text: '低16节电压数据' },
        { value: 0x58, bkv: '', key: 'device.high_cell_voltage', text: '高16节电压数据' },
        { value: 0x59, bkv: '', key: 'device.battery_most_value_log', text: '电池最值记录' },
        { value: 0x60, bkv: '', key: 'device.error_count', text: '错误计数' },
        { value: 0x67, bkv: '', key: 'device.battery_status', text: '电池状态' },
        { value: 0x71, bkv: '', key: 'device.temperature', text: '温度' },
        { value: 0x72, bkv: '', key: 'device.gprs_stat', text: 'GPRS数据量统计' },
        { value: 0x73, bkv: '', key: 'device.dtu_software_version', text: '软件版本' },
        { value: 0x74, bkv: '', key: 'device.bms_software_version', text: 'BMS软件版本' },
        { value: 0x75, bkv: '', key: 'device.bluetooth_mac', text: '蓝牙 MAC' },
        { value: 0xE1, bkv: '', key: 'device.iccid', text: 'ICCID' },
        { value: 0xE2, bkv: '', key: 'device.imei', text: 'IMEI' },
        { value: 0xE3, bkv: '', key: 'device.gprs_apn', text: 'GPRS APN' },
        { value: 0xE4, bkv: '', key: 'device.bluetooth_password', text: '蓝牙连接密码' },

        { value: 0xE5, bkv: '', key: 'device.gprs_apn', text: 'GPRS APN' },
        { value: 0xE6, bkv: '', key: 'device.bluetooth_password', text: '蓝牙连接密码' },
        { value: 0x78, bkv: '', key: 'device.module_access_parameters', text: '模块接入参数' },
        { value: 0x79, bkv: '', key: 'device.activate_module_upgrade', text: '激活模块升级' },
        { value: 0x80, bkv: '', key: 'device.set_battery', text: '配置电池' },
        { value: 0x81, bkv: '', key: 'device.electronic_fence', text: '设置电子围栏' },
    ]
}

export default {
    name: "CustomRead",
    components: {},
    props: {
        btnType: { type: String, default: 'primary', },
        btnText: { type: String },

        uid: { type: [String] },
        id:  { type: [String, Number] },
        space: { type: [String, Number] },
    },
    data() {
        return {
            loading: false,
            dialogShow: false,

            bkv: '',
            cmdList: [], // 可选的指令
            selectCmd: [], // 已选的指令
        }
    },
    mounted() {},
    methods: {
        handleDialogShow() {
            this.cmdList = Core.Util.deepCopy(CMD_LIST[this.space + '']) || [];
            this.dialogShow = true;
            this.loading = false;
        },
        handleDialogClose() {
            this.dialogShow = false;
            this.bkv = '';
            this.cmdList = [];
            this.selectCmd = [];
        },
        handleDialogConfirm() {
            console.log('handleDialogConfirm this.bkv:', this.bkv)
            if (!this.selectCmd.length) {
                return this.$message.warning('请至少选择一项操作');
            }
            this.loading = true
            let apiName = 'Fengine' + this.space;
            Core.Api[apiName].sendCmd({
                id: this.uid,
                bkv: this.bkv,
            }).then(() => {
                this.$message.success(this.$t(/*操作成功*/'c.oper_success'));
                this.$emit('change');
                this.handleDialogClose();
            }).catch(err => {
                console.log('handleDialogConfirm err:', err);
                this.loading = false;
            })
        },

        // 选择变更
        handleChange(flag, index) {
            this.bkv = this.selectCmd.length ? Core.Util.arrayBufferToHex(makeReadFrame(...this.selectCmd)) : '';
            let b = new BKV();
            b.addByNumberKey(this.cmdList[index].value, new Uint8Array(0));
            this.cmdList[index].bkv = flag ? Core.Util.arrayBufferToHex(b.pack()) : '';
        },
        // 全选
        handleSelectAll() {
            if (this.selectCmd.length === this.cmdList.length) { return }
            let selectCmd = []
            for (let i = 0; i < this.cmdList.length; i++) {
                let item = this.cmdList[i];
                selectCmd.push(item.value);
                let b = new BKV();
                b.addByNumberKey(item.value, new Uint8Array(0));
                item.bkv = Core.Util.arrayBufferToHex(b.pack());
            }
            this.selectCmd = selectCmd;
            this.bkv = Core.Util.arrayBufferToHex(makeReadFrame(...this.selectCmd));
        },
        // 全不选
        handleClearSelect() {
            if (!this.selectCmd.length) { return }
            this.bkv = '';
            this.selectCmd = [];
            for (let i = 0; i < this.cmdList.length; i++) {
                this.cmdList[i].bkv = '';
            }
        }
    }
}
</script>

<style scoped lang="scss">
.CustomReadBtn {
    width: 150px;
    margin-left: 20px;
    margin-bottom: 12px;
}
.CustomReadDialog {
    .checkbox-item {
        width: calc(50% - 30px);
        margin-bottom: 6px;
    }
}
</style>
